function Footer() {
  return (
    <footer className="bg-[#1a1a1a] text-white py-16 px-6">
      <div className="max-w-[1200px] mx-auto">

        {/* Footer Grid */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12 border-b border-white/15 pb-12">

          {/* Column 1 - Brand */}
          <div className="col-span-1 text-center md:text-left">
            <div className="flex items-center justify-center md:justify-start gap-3 mb-6">
              <h2 className="text-white text-xl font-bold">Motif Farms & Agro Processing</h2>
            </div>
            <p className="text-gray-300 text-sm leading-relaxed">
              Dedicated to raising the healthiest turkeys and processing high-quality poultry products for your health and satisfaction.
            </p>
          </div>

          {/* Column 2 - Quick Links */}
          <div className="text-center md:text-left">
            <h4 className="font-bold text-lg mb-6">Quick Links</h4>
            <ul className="space-y-4 text-sm text-gray-300">
              <li><a className="hover:text-primary transition-colors" href="#about">About Our Farm</a></li>
              <li><a className="hover:text-primary transition-colors" href="#products">Our Products</a></li>
              <li><a className="hover:text-primary transition-colors" href="#gallery">Photo Gallery</a></li>
              <li><a className="hover:text-primary transition-colors" href="#order">Contact Us</a></li>
            </ul>
          </div>

          {/* Column 3 - Products */}
          <div className="text-center md:text-left">
            <h4 className="font-bold text-lg mb-6">Products</h4>
            <ul className="space-y-4 text-sm text-gray-300">
              <li>Fertile Turkey Eggs</li>
              <li>Day-Old Turkey Poults</li>
              <li>Mature Live Turkeys</li>
              <li>Processed Turkey Meat</li>
              <li>High-Protein Poultry Feed</li>
            </ul>
          </div>

          {/* Column 4 - Visit Us */}
          <div className="text-center md:text-left">
            <h4 className="font-bold text-lg mb-6">Visit Us</h4>
            <p className="text-sm text-gray-300 mb-4">
              Medie–Kotoku, Accra, Ghana
            </p>
            <div className="flex items-center justify-center md:justify-start gap-3 text-sm text-gray-300 mb-4">
              <span className="material-symbols-outlined text-primary text-lg">call</span>
              <span className="font-medium">055 745 5228</span>
            </div>
            <div className="flex items-center justify-center md:justify-start gap-3 text-sm text-gray-300 mb-6">
              <span className="material-symbols-outlined text-primary text-lg flex-shrink-0">mail</span>
              <span className="font-medium break-all">motifinvestmentsghana@gmail.com</span>
            </div>

            {/* Social Links */}
            <div className="flex justify-center md:justify-start gap-4">
              {/* Instagram */}
              <a
                className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-primary transition-all"
                href="https://www.instagram.com/motiffarmsgh"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
              >
                <span className="material-symbols-outlined text-sm">photo_camera</span>
              </a>
              {/* WhatsApp */}
              <a
                className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-primary transition-all"
                href="https://wa.me/233557455228"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="WhatsApp"
              >
                <span className="material-symbols-outlined text-sm">chat</span>
              </a>
              {/* Email */}
              <a
                className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-primary transition-all"
                href="mailto:motifinvestmentsghana@gmail.com"
                aria-label="Email"
              >
                <span className="material-symbols-outlined text-sm">mail</span>
              </a>
            </div>
          </div>

        </div>

        {/* Bottom Bar */}
        <div className="flex flex-col md:flex-row justify-between items-center text-sm text-gray-500">
          <p>© 2025 Motif Farms & Agro Processing. All rights reserved.</p>
          <div className="flex gap-6 mt-4 md:mt-0">
            <a className="hover:text-white transition-colors" href="#">Privacy Policy</a>
            <a className="hover:text-white transition-colors" href="#">Terms of Service</a>
          </div>
        </div>

      </div>
    </footer>
  );
}

export default Footer;